import {required, email, minLength, maxLength} from 'react-admin'

export const companyValidation = [required(), minLength(2), maxLength(255)];
export const emailValidation = [required(), email(), minLength(5), maxLength(255)];
export const firstNameValidation = [required(), minLength(2), maxLength(255)];
export const lastNameValidation = [required(), minLength(2), maxLength(255)];
export const passwordValidation = [required(), minLength(10)];